import { HStack, VStack, Image, Text, Box, useBreakpointValue } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { CircleIcon } from "../../../assets/icons/components";
import { NeedHelpWomen } from "../../../assets/images";
import useCleverTap, {
  ButtonTypes,
  CleverTapEvents,
  ScreenNames,
} from "../../../clevertap/useCleverTap";
import { sendTrackingEvent } from "../utils/gtm";
import { useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import { AppContext } from "../../../context/ApplicationContext";
import ModalTemplate from "./ModalTemplate";
import NeedHelpModalContent from "./NeedHelpModalContent";
import BookADemoModal from "../../cap-program/BookADemoModal/DemoModal";

interface Props {
  onClick?: () => void;
  link?: string;
}

const NeedHelp = ({ onClick, link }: Props) => {
  const location = useLocation();
  const breakpointValue = useBreakpointValue({ base: true, md: false });
  const state = useContext(AppContext)[0];
  const clevertap = useCleverTap()[0];
  const [isNeedHelpModalOpen, setIsNeedHelpModalOpen] = useState(false);
  const [openCalendlyModal, setOpenCalendlyModal] = useState<boolean>(false);
  const onclickTracker = () => {
    sendTrackingEvent({ event: "dash-speak_to_our_team", eventLabel: location.pathname });
    clevertap.fireEvent(CleverTapEvents.click_dashboard_navigation_tab, {
      screen_name: ScreenNames.dashboardCourses,
      button_text: "book a slot",
      button_type: ButtonTypes.link,
      button_sequence: 5,
      bottom_navigation: breakpointValue,
    });
  };
  const handleBookSlot = (program : string) => {
    if (program ==="cap") {
      setOpenCalendlyModal(true);
    }else {
      window.open(" https://zoom.us/meeting/register/tJMlfu-prTIqE9C1Ol8PyAxAmDQDbV6BtCD-", "_blank")
    }
  }
  return (

    <>
      <Box
        cursor={"pointer"}
        onClick={() => {
          setIsNeedHelpModalOpen(true);
          onclickTracker();
        }}
      >
        <HStack h="64px" bg="ms-red.50" borderRadius="ms-8" position="relative" overflow="hidden">
          <Box w="78px" h="full">
            <Box position="absolute" bg="ms-grey.50" borderRadius="0 50% 50% 0">
              <Image w="4rem" src={NeedHelpWomen} borderRightRadius="100%" />
              <Box position="absolute" top="ms-8" right="-2px">
                <CircleIcon
                  color="ms-success"
                  boxSize="0.5rem"
                  border="1px solid"
                  borderColor="ms-red.50"
                  borderRadius="full"
                />
              </Box>
            </Box>
          </Box>
          <VStack spacing="ms-4" align="flex-start">
            <Text textStyle="body2-md" color="ms-purple.500">
              Speak to our Team
            </Text>
            <HStack spacing="ms-4">
              <Text textStyle="caption" color="ms-grey.700">
                Book a slot
              </Text>
              <ChevronRightIcon color="ms-grey.700" />
            </HStack>
          </VStack>
        </HStack>
        {/* </Link> */}
      </Box>
      <ModalTemplate
        title=""
        isOpen={isNeedHelpModalOpen}
        onClose={() => {
          setIsNeedHelpModalOpen(false);
        }}
        showCloseButtonIcon={true}
        marginX={2}
        maxWidth="472px"
      >
        <NeedHelpModalContent setIsNeedHelpModalOpen={setIsNeedHelpModalOpen} onBookSlot={handleBookSlot}/>
      </ModalTemplate>
      <BookADemoModal
        setShowModal={setOpenCalendlyModal}
        showModal={openCalendlyModal}
        phone={null}
        startingStep={1}
        source = {localStorage.getItem("source") || "dashboard_speak_to_our_team_cap" }
      />
    </>
  );
};

export default NeedHelp;
